import { Deserializable } from '../deserializable.model';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class PropertySearchModel implements Deserializable {
  Purpose: any;
  City: any;
  Location: any;
  Keywords: any;
  PropertyType: any;
  BedRooms: any;
  BathRooms: any;
  AreaUnit: any;
  MinArea: any;
  MaxArea: any;
  MinPrice: any;
  MaxPrice: any;
  OtherFeatures: any;

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
}

export interface PropertyListing {
  UserName: string;
  PropertyId: number;
  Title: string;
  Location: string;
  Purpose: string;
  Price: string;
  BedRooms: string;
  BathRooms: string;
  AreaUnit: string;
  Images: string[];
  PublishDate: string;
}


export interface Select2Data {
  Id: number;
  Text: string;
}
